<template>
  <div class="contato-view">
    <section class="banner-contato parallax-window" data-parallax="scroll">
      <div class="container text-center">
        <h1>Precisa de ajuda?</h1>
        <div class="cta-banner text-center">
          <a href="#" class="btn btn-primary">Acesse o nosso help center</a>
        </div>
      </div>
    </section>

    <section class="form-contato pt-5 pb-5">
      <div class="container">
        <form>
          <div class="row">
            <div class="col-12 col-md-6">
              <form-group id="nome" label="Nome" :text="{ required: 'Obrigatório informar o seu nome' }" :field="$v.nome">
                <input type="text" class="form-control" v-model="nome">
              </form-group>

              <form-group id="email" label="E-mail" :text="{ required: 'Obrigatório informar o seu e-mail', email: 'E-mail inválido' }" :field="$v.email">
                <input type="text" class="form-control" v-model="email">
              </form-group>

              <form-group id="assunto" label="Assunto" :text="{ required: 'Obrigatório informar o assunto' }" :field="$v.assunto">
                <input type="text" class="form-control" v-model="assunto">
              </form-group>
            </div>
            <div class="col-12 col-md-6">
              <form-group id="mensagem" label="Mensagem" :text="{ required: 'Obrigatório informar a mensagem' }" :field="$v.mensagem">
                <textarea class="form-control" rows="7" v-model="mensagem"></textarea>
              </form-group>
            </div>
            <div class="col-12 mt-4" v-if="false">
              <label for="anexar">Anexar um print ou arquivo</label>
              <div class="upload-contato">
                <div class="text-center">
                  <img :src="require('@/assets/img/upload.png')" alt="Ilustração de uma nuvem" />
                  <p v-if="files.length">Arquivo <strong>{{ files[0].name }}</strong> anexado. <a href="javascript:void(0)" @click.prevent="$refs.upload.remove(files[0])"><i class="fas fa-times"></i> Remover</a></p>
                  <p v-else>Arraste e solte um arquivo para anexar ou <a href="javascript:void(0)" @click="selecionarArquivo">busque um arquivo</a></p>

                  <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
                    <h3>Solte o arquivo para anexar</h3>
                  </div>

                  <file-upload
                    post-action="/upload/post"
                    :drop="true"
                    v-model="files"
                    ref="upload"
                    v-show="false">
                    busque um arquivo
                  </file-upload>

                </div>
              </div>
            </div>

            <div class="col-12 text-center mt-5">
              <a href="javascript:void(0)" @click="enviarMensagem" class="btn btn-primary">Enviar</a>
            </div>
          </div>
        </form>
      </div>
    </section>
    <section class="canais-atendimento pb-5" v-if="false">
      <div class="container">
        <span class="bg-destaques"></span>
        <div class="row">
          <div class="col-12 col-md-3">
            <div class="d-flex align-items-center mt-md-3 ml-md-5">
              <a href="#" class="d-flex align-items-center">
                <i class="fab fa-whatsapp"></i>
                <div>
                  <p>WhatsApp</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="d-flex align-items-center mt-md-3 ml-md-5">
              <a href="#" class="d-flex align-items-center">
                <i class="fab fa-instagram"></i>
                <div>
                  <p>Instagram</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="d-flex align-items-center mt-md-3 ml-md-5">
              <a href="#" class="d-flex align-items-center">
                <i class="fab fa-facebook-f"></i>
                <div>
                  <p>Facebook</p>
                </div>
              </a>
            </div>
          </div>
          <div class="col-12 col-md-3">
            <div class="d-flex align-items-center mt-md-3 ml-md-5">
              <a href="#" class="d-flex align-items-center">
                <i class="fab fa-youtube"></i>
                <div>
                  <p>Youtube</p>
                </div>
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>

    <voll-chat />
  </div>
</template>

<script>
import $ from 'jquery'
import { required, email } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import FileUpload from 'vue-upload-component'
import Swal from 'sweetalert2'
import ContatoAPI from '@/api/contato-api'
import ResponseUtils from '@/core/utils/response-utils'
import VollChat from '@/core/components/chat/VollChat'

export default {
  name: 'ContatoView',
  components: { VollChat, FormGroup, FileUpload },
  data () {
    return {
      nome: '',
      email: '',
      assunto: '',
      mensagem: '',
      files: []
    }
  },

  validations: {
    nome: { required },
    email: { required, email },
    assunto: { required },
    mensagem: { required }
  },

  created () {
    setTimeout(function () {
      $('.parallax-window').parallax({ imageSrc: require('@/assets/img/bannercontato.jpg') })
    }, 100)
  },
  beforeDestroy () {
    $('.parallax-mirror').remove()
  },

  methods: {
    selecionarArquivo: function () {
      this.$el.querySelector('[name="file"]').click()
    },

    enviarMensagem: function () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const loader = this.$loading.show()

        this.$v.$reset()

        ContatoAPI.enviarContato(this.nome, this.email, this.assunto, this.mensagem).then(data => {
          if (data.type) {
            Swal.fire(
              'Enviado!',
              'Sua mensagem foi enviada!',
              'success'
            )
            Object.assign(this.$data, this.$options.data.apply(this))
          }
          loader.hide()
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    }
  }
}
</script>

<style>
  .contato-view .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
  }
  .contato-view .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }
</style>
